/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  useMemo,
  useCallback,
  useContext,
} from 'react';

import PropTypes from 'prop-types';

/* Qlik */
import useQlikSessionObject from 'hooks/useQlikSessionObject';

import injectSheet from 'react-jss';

import AppContext from '../AppContext';

const styles = {
  filter: () => ({
    marginBottom: 20,
  }),
  list: (props) => ({
    display: props.flex ? 'flex' : 'block',
    maxWidth: 300,
    listStyleType: 'none',
    flexFlow: props.reverse ? 'wrap-reverse' : 'wrap',
    flexDirection: props.reverse ? 'row-reverse' : 'column',
    fontSize: 12,
    justifyContent: 'space-between',
    height: props.height,
    overflow: 'auto',
    padding: 0,
  }),
  item: {
    padding: 5,
    cursor: 'pointer',
  },
  title: {
    fontSize: 16,
    cursor: 'pointer',
    fontFamily: 'League Gothic',
  },
};

const Filter = ({
  classes,
  title,
  field,
  sort,
}) => {
  const qlikApp = useContext(AppContext);

  // Get ListObject
  const qFilter = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qInfo: { qType: 'dataFilter' },
      qListObjectDef: {
        qDef: {
          qFieldDefs: [field],
          qFieldLabels: [title],
          qSortCriterias: [sort],
        },
        qInitialDataFetch: [{ qWidth: 1, qHeight: 1000 }],
        qShowAlternatives: true,
      },
    },
  });

  const options = useMemo(() => {
    if (!qFilter.layout) return [];

    return qFilter.layout.qListObject.qDataPages[0].qMatrix.map((row) => ({
      qElemNumber: row[0].qElemNumber,
      qState: row[0].qState,
      qText: row[0].qText,
      qFrequency: row[0].qFrequency,
    }));
  }, [qFilter]);

  const handleSelection = useCallback((qElemNumber) => {
    if (!qFilter.model) return;

    qFilter.model.selectListObjectValues('/qListObjectDef', [qElemNumber], true);
  }, [qFilter.model]);

  return (
    <div open className={classes.filter}>
      <summary className={classes.title}>
        {title}
      </summary>
      <ul className={classes.list}>
        {
            options.map((row) => (
              <li
                className={classes.item}
                key={row.qElemNumber}
                onClick={() => handleSelection(row.qElemNumber)}
                style={{
                  background: (() => {
                    if (row.qState === 'S') return '#52CC52';
                    if (row.qState === 'A') return '#ddd';
                    if (row.qState === 'X') return '#A9A9A9';
                    return 'inherit';
                  })(),
                  color: (() => {
                    if (row.qState === 'S') return 'white';
                    if (row.qState === 'X') return 'white';
                    return 'inherit';
                  })(),
                }}
              >
                {row.qText}
              </li>
            ))
        }

      </ul>
    </div>
  );
};

Filter.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  sort: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Filter);
